import httpClient from './http-client';
import mockWarrantService from './warrant.service.mock';

let warrantService;

if (process.env.NODE_ENV === 'development') {
  warrantService = mockWarrantService;
} else {
  warrantService = {
    // params: type, validFrom, validTo, page, pageSize
    getList(params) {
      return httpClient.get('/warrant', { params });
    },

    confirm(warrantId) {
      return httpClient.post(`/warrant/confirm/${warrantId}`);
    },

    delete(warrantIds) {
      const payload = {
        warrantId: warrantIds,
      };
      return httpClient.delete('/warrant', { data: payload });
    },

    cancel(warrantId) {
      return httpClient.post(`/warrant/revoke/${warrantId}`);
    },

    getById(id) {
      return httpClient.get(`/warrant/${id}`);
    },

    init() {
      return httpClient.post('/warrant/init');
    },

    // params: eptpSystem, type, query
    getResourceList(params) {
      return httpClient.post('/warrant/resource', { params });
    },

    update(warrant) {
      return httpClient.put('/warrant/update', warrant);
    },

    getAttachment(warrantId, attachmentId) {
      const params = {
        warrantId,
        attachmentId,
      };

      return httpClient({
        url: '/warrant/attachment',
        method: 'GET',
        responseType: 'blob',
        params,
      });
    },

    createAttachment(warrantId, file) {
      const body = new FormData();
      body.append('file', file);
      const params = {
        warrantId,
      };
      return httpClient.post('/warrant/attachment', body, { params });
    },

    deleteAttachment(warrantId, attachmentId) {
      const params = {
        warrantId,
        attachmentId,
      };
      return httpClient.delete('/warrant/attachment', { params });
    },
  };
}

export default warrantService;
